import React from 'react';
import { Breadcrumb as AntdBreadcrumb } from 'antd';
import BreadcrumbSeparator from './BreadcrumbSeparator';
import { ConfigContext } from '../config-provider';
import BreadcrumbItem, { BreadcrumbItemProps } from './BreadcrumbItem';
import { Menu } from '../menu';
import { Icon } from '../icon';
const Breadcrumb = (props) => {
    const { maxNode: customizeMaxNode, children, separator, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('breadcrumb', props.prefixCls);
    const mergeSeparator = separator ? separator : React.createElement(Icon, { type: 'slash' });
    const renderBreadcrumbNode = () => {
        if (typeof customizeMaxNode === 'undefined') {
            return props.children;
        }
        const maxNode = Math.max(3, customizeMaxNode);
        // Only count BreadcrumbItem when maxNode props is available.
        const itemChildren = React.Children.toArray(props.children).filter((child) => child.type.displayName === 'BreadcrumbItem');
        const totalNodes = itemChildren.length;
        if (totalNodes > maxNode) {
            // Make the omitted nodes an overlay menu for the ellipse item.
            const externalizedChildren = itemChildren.slice(1, totalNodes - maxNode + 1);
            const overflowMenu = (React.createElement(Menu, null, externalizedChildren.map((breadcrumbItem, index) => {
                return React.createElement(Menu.Item, { key: index }, breadcrumbItem.props.children);
            })));
            const overlayItem = (React.createElement(BreadcrumbItem, { className: `${prefixCls}-ellipse-omit`, overlay: overflowMenu },
                React.createElement(Icon, { type: 'overflow-menu--horizontal' })));
            let computedChildren = [itemChildren[0], overlayItem, ...itemChildren.slice(totalNodes - maxNode + 1)];
            computedChildren = computedChildren.map((child, index) => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { key: index });
                }
                else {
                    return child;
                }
            });
            return computedChildren;
        }
    };
    return (React.createElement(AntdBreadcrumb, { ...otherProps, prefixCls: prefixCls, separator: mergeSeparator }, renderBreadcrumbNode()));
};
Breadcrumb.Item = BreadcrumbItem;
Breadcrumb.Separator = BreadcrumbSeparator;
export default Breadcrumb;
